import { createContext, useContext } from "react";
import { noop } from "@common/helpers/function";
import { CommandsDirectory, CommandsOptions } from "./lib";

interface ICommandsContext {
    isOpen: boolean;
    open(directory?: CommandsDirectory, options?: CommandsOptions): void;
    close(): void;
    /** Goes back to the first directory opened, or closes when already there. */
    returnToRoot(): void;
    /** Swaps the open palette's options so its lists reflect fresh state. */
    replaceOptions(options: CommandsOptions): void;
    /**
     * Makes mod+K call `fn` instead of opening the palette. Returns a release
     * that clears the slot only while this registration still holds it.
     */
    registerOpenOverride(fn: () => void): () => void;
    /** Clears the slot whoever holds it. */
    unregisterOpenOverride(): void;
}

const commandsContext = createContext<ICommandsContext>({
    isOpen: false,
    open: noop,
    close: noop,
    returnToRoot: noop,
    replaceOptions: noop,
    registerOpenOverride: () => noop,
    unregisterOpenOverride: noop,
});

export const CommandsContextProvider = commandsContext.Provider;

export function useCommands() {
    const context = useContext(commandsContext);

    if (!context) {
        throw new Error("useCommands must be used within a CommandsProvider");
    }

    return context;
}
